module.exports = __webpack_public_path__ + "static/jade1-dc6552c956058819e9b68246aafa4475.png";